<template>
  <div class="quiz-form">
    <div class="quiz-form__inner">
      <div class="quiz-input">
        <input
          v-model="input"
          type="test"
          inputmode="numeric"
          :placeholder="placeholder"
        />
      </div>
      <div v-if="skip" class="quiz-skip" @click="$emit('next', 'don`t know')">
        <div>Not sure.</div>
        <div>Skip question</div>
      </div>
    </div>
    <button class="quiz-btn" type="button" :disabled="!input" @click="$emit('next', input)">
      Next
    </button>
  </div>
</template>

<script>
export default {
  emits: ['next'],
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    skip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      input: null
    }
  },
}
</script>